import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import h, { levels as s } from "pino";
import { default as U } from "pino";
import { safeJsonStringify as u } from "@walletconnect/safe-json";
var c = {
    level: "info"
  },
  n = "custom_context",
  l = 1e3 * 1024;
var O = /*#__PURE__*/function () {
  function O(e) {
    _classCallCheck(this, O);
    this.nodeValue = e, this.sizeInBytes = new TextEncoder().encode(this.nodeValue).length, this.next = null;
  }
  _createClass(O, [{
    key: "value",
    get: function get() {
      return this.nodeValue;
    }
  }, {
    key: "size",
    get: function get() {
      return this.sizeInBytes;
    }
  }]);
  return O;
}();
var d = /*#__PURE__*/function (_Symbol$iterator) {
  function d(e) {
    _classCallCheck(this, d);
    this.head = null, this.tail = null, this.lengthInNodes = 0, this.maxSizeInBytes = e, this.sizeInBytes = 0;
  }
  _createClass(d, [{
    key: "append",
    value: function append(e) {
      var t = new O(e);
      if (t.size > this.maxSizeInBytes) throw new Error("[LinkedList] Value too big to insert into list: ".concat(e, " with size ").concat(t.size));
      for (; this.size + t.size > this.maxSizeInBytes;) this.shift();
      this.head ? (this.tail && (this.tail.next = t), this.tail = t) : (this.head = t, this.tail = t), this.lengthInNodes++, this.sizeInBytes += t.size;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (!this.head) return;
      var e = this.head;
      this.head = this.head.next, this.head || (this.tail = null), this.lengthInNodes--, this.sizeInBytes -= e.size;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var e = [];
      var t = this.head;
      for (; t !== null;) e.push(t.value), t = t.next;
      return e;
    }
  }, {
    key: "length",
    get: function get() {
      return this.lengthInNodes;
    }
  }, {
    key: "size",
    get: function get() {
      return this.sizeInBytes;
    }
  }, {
    key: "toOrderedArray",
    value: function toOrderedArray() {
      return Array.from(this);
    }
  }, {
    key: _Symbol$iterator,
    value: function value() {
      var e = this.head;
      return {
        next: function next() {
          if (!e) return {
            done: !0,
            value: null
          };
          var t = e.value;
          return e = e.next, {
            done: !1,
            value: t
          };
        }
      };
    }
  }]);
  return d;
}(Symbol.iterator);
var L = /*#__PURE__*/function () {
  function L(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : l;
    _classCallCheck(this, L);
    this.level = e !== null && e !== void 0 ? e : "error", this.levelValue = s.values[this.level], this.MAX_LOG_SIZE_IN_BYTES = t, this.logs = new d(this.MAX_LOG_SIZE_IN_BYTES);
  }
  _createClass(L, [{
    key: "forwardToConsole",
    value: function forwardToConsole(e, t) {
      t === s.values.error ? console.error(e) : t === s.values.warn ? console.warn(e) : t === s.values.debug ? console.debug(e) : t === s.values.trace ? console.trace(e) : console.log(e);
    }
  }, {
    key: "appendToLogs",
    value: function appendToLogs(e) {
      this.logs.append(u({
        timestamp: new Date().toISOString(),
        log: e
      }));
      var t = typeof e == "string" ? JSON.parse(e).level : e.level;
      t >= this.levelValue && this.forwardToConsole(e, t);
    }
  }, {
    key: "getLogs",
    value: function getLogs() {
      return this.logs;
    }
  }, {
    key: "clearLogs",
    value: function clearLogs() {
      this.logs = new d(this.MAX_LOG_SIZE_IN_BYTES);
    }
  }, {
    key: "getLogArray",
    value: function getLogArray() {
      return Array.from(this.logs);
    }
  }, {
    key: "logsToBlob",
    value: function logsToBlob(e) {
      var t = this.getLogArray();
      return t.push(u({
        extraMetadata: e
      })), new Blob(t, {
        type: "application/json"
      });
    }
  }]);
  return L;
}();
var m = /*#__PURE__*/function () {
  function m(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : l;
    _classCallCheck(this, m);
    this.baseChunkLogger = new L(e, t);
  }
  _createClass(m, [{
    key: "write",
    value: function write(e) {
      this.baseChunkLogger.appendToLogs(e);
    }
  }, {
    key: "getLogs",
    value: function getLogs() {
      return this.baseChunkLogger.getLogs();
    }
  }, {
    key: "clearLogs",
    value: function clearLogs() {
      this.baseChunkLogger.clearLogs();
    }
  }, {
    key: "getLogArray",
    value: function getLogArray() {
      return this.baseChunkLogger.getLogArray();
    }
  }, {
    key: "logsToBlob",
    value: function logsToBlob(e) {
      return this.baseChunkLogger.logsToBlob(e);
    }
  }, {
    key: "downloadLogsBlobInBrowser",
    value: function downloadLogsBlobInBrowser(e) {
      var t = URL.createObjectURL(this.logsToBlob(e)),
        o = document.createElement("a");
      o.href = t, o.download = "walletconnect-logs-".concat(new Date().toISOString(), ".txt"), document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(t);
    }
  }]);
  return m;
}();
var B = /*#__PURE__*/function () {
  function B(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : l;
    _classCallCheck(this, B);
    this.baseChunkLogger = new L(e, t);
  }
  _createClass(B, [{
    key: "write",
    value: function write(e) {
      this.baseChunkLogger.appendToLogs(e);
    }
  }, {
    key: "getLogs",
    value: function getLogs() {
      return this.baseChunkLogger.getLogs();
    }
  }, {
    key: "clearLogs",
    value: function clearLogs() {
      this.baseChunkLogger.clearLogs();
    }
  }, {
    key: "getLogArray",
    value: function getLogArray() {
      return this.baseChunkLogger.getLogArray();
    }
  }, {
    key: "logsToBlob",
    value: function logsToBlob(e) {
      return this.baseChunkLogger.logsToBlob(e);
    }
  }]);
  return B;
}();
var x = Object.defineProperty,
  S = Object.defineProperties,
  _ = Object.getOwnPropertyDescriptors,
  p = Object.getOwnPropertySymbols,
  T = Object.prototype.hasOwnProperty,
  z = Object.prototype.propertyIsEnumerable,
  f = function f(r, e, t) {
    return e in r ? x(r, e, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : r[e] = t;
  },
  i = function i(r, e) {
    for (var t in e || (e = {})) T.call(e, t) && f(r, t, e[t]);
    if (p) {
      var _iterator = _createForOfIteratorHelper(p(e)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          z.call(e, t) && f(r, t, e[t]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return r;
  },
  g = function g(r, e) {
    return S(r, _(e));
  };
function k(r) {
  return g(i({}, r), {
    level: (r === null || r === void 0 ? void 0 : r.level) || c.level
  });
}
function v(r) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : n;
  return r[e] || "";
}
function b(r, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : n;
  return r[t] = e, r;
}
function y(r) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : n;
  var t = "";
  return typeof r.bindings > "u" ? t = v(r, e) : t = r.bindings().context || "", t;
}
function w(r, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : n;
  var o = y(r, t);
  return o.trim() ? "".concat(o, "/").concat(e) : e;
}
function E(r, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : n;
  var o = w(r, e, t),
    a = r.child({
      context: o
    });
  return b(a, o, t);
}
function C(r) {
  var e, t;
  var o = new m((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
  return {
    logger: h(g(i({}, r.opts), {
      level: "trace",
      browser: g(i({}, (t = r.opts) == null ? void 0 : t.browser), {
        write: function write(a) {
          return o.write(a);
        }
      })
    })),
    chunkLoggerController: o
  };
}
function I(r) {
  var e;
  var t = new B((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
  return {
    logger: h(g(i({}, r.opts), {
      level: "trace"
    }), t),
    chunkLoggerController: t
  };
}
function A(r) {
  return typeof r.loggerOverride < "u" && typeof r.loggerOverride != "string" ? {
    logger: r.loggerOverride,
    chunkLoggerController: null
  } : typeof window < "u" ? C(r) : I(r);
}
export { l as MAX_LOG_SIZE_IN_BYTES_DEFAULT, n as PINO_CUSTOM_CONTEXT_KEY, c as PINO_LOGGER_DEFAULTS, w as formatChildLoggerContext, E as generateChildLogger, C as generateClientLogger, A as generatePlatformLogger, I as generateServerLogger, v as getBrowserLoggerContext, k as getDefaultLoggerOptions, y as getLoggerContext, U as pino, b as setBrowserLoggerContext };